// @generated by protobuf-ts 2.8.2 with parameter output_javascript
// @generated from protobuf file "department_labor_rates.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.2 with parameter output_javascript
// @generated from protobuf file "department_labor_rates.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentLaborRate$Type extends MessageType {
    constructor() {
        super("DepartmentLaborRate", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "hourly_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "effective_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "department_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { id: 0, departmentId: 0, hourlyRate: 0, effectiveDate: "", createdBy: 0, createdAt: "", updatedAt: "", isActive: false, fieldMask: [], pageNumber: 0, departmentDescription: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* double hourly_rate */ 3:
                    message.hourlyRate = reader.double();
                    break;
                case /* string effective_date */ 4:
                    message.effectiveDate = reader.string();
                    break;
                case /* int32 created_by */ 5:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 7:
                    message.updatedAt = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string department_description */ 11:
                    message.departmentDescription = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* double hourly_rate = 3; */
        if (message.hourlyRate !== 0)
            writer.tag(3, WireType.Bit64).double(message.hourlyRate);
        /* string effective_date = 4; */
        if (message.effectiveDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.effectiveDate);
        /* int32 created_by = 5; */
        if (message.createdBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.createdBy);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 7; */
        if (message.updatedAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.updatedAt);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string department_description = 11; */
        if (message.departmentDescription !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.departmentDescription);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DepartmentLaborRate
 */
export const DepartmentLaborRate = new DepartmentLaborRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentLaborRateList$Type extends MessageType {
    constructor() {
        super("DepartmentLaborRateList", [
            { no: 1, name: "results", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DepartmentLaborRate },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = { results: [], totalCount: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated DepartmentLaborRate results */ 1:
                    message.results.push(DepartmentLaborRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated DepartmentLaborRate results = 1; */
        for (let i = 0; i < message.results.length; i++)
            DepartmentLaborRate.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DepartmentLaborRateList
 */
export const DepartmentLaborRateList = new DepartmentLaborRateList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectLaborRate$Type extends MessageType {
    constructor() {
        super("ProjectLaborRate", [
            { no: 1, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "hourly_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "rate_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "department_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { projectId: 0, departmentId: 0, hourlyRate: 0, rateDate: "", createdAt: "", fieldMask: [], pageNumber: 0, departmentDescription: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_id */ 1:
                    message.projectId = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* double hourly_rate */ 3:
                    message.hourlyRate = reader.double();
                    break;
                case /* string rate_date */ 4:
                    message.rateDate = reader.string();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* string department_description */ 8:
                    message.departmentDescription = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_id = 1; */
        if (message.projectId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectId);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* double hourly_rate = 3; */
        if (message.hourlyRate !== 0)
            writer.tag(3, WireType.Bit64).double(message.hourlyRate);
        /* string rate_date = 4; */
        if (message.rateDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.rateDate);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* string department_description = 8; */
        if (message.departmentDescription !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.departmentDescription);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectLaborRate
 */
export const ProjectLaborRate = new ProjectLaborRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectLaborRateList$Type extends MessageType {
    constructor() {
        super("ProjectLaborRateList", [
            { no: 1, name: "results", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ProjectLaborRate },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = { results: [], totalCount: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectLaborRate results */ 1:
                    message.results.push(ProjectLaborRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectLaborRate results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectLaborRate.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectLaborRateList
 */
export const ProjectLaborRateList = new ProjectLaborRateList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectLaborRateRequest$Type extends MessageType {
    constructor() {
        super("ProjectLaborRateRequest", [
            { no: 1, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { projectId: 0, fieldMask: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_id */ 1:
                    message.projectId = reader.int32();
                    break;
                case /* repeated string field_mask */ 2:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_id = 1; */
        if (message.projectId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectId);
        /* repeated string field_mask = 2; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectLaborRateRequest
 */
export const ProjectLaborRateRequest = new ProjectLaborRateRequest$Type();
/**
 * @generated ServiceType for protobuf service DepartmentLaborRatesService
 */
export const DepartmentLaborRatesService = new ServiceType("DepartmentLaborRatesService", [
    { name: "CreateDepartmentLaborRate", options: {}, I: DepartmentLaborRate, O: DepartmentLaborRate },
    { name: "GetDepartmentLaborRate", options: {}, I: DepartmentLaborRate, O: DepartmentLaborRate },
    { name: "BatchGetDepartmentLaborRate", options: {}, I: DepartmentLaborRate, O: DepartmentLaborRateList },
    { name: "UpdateDepartmentLaborRate", options: {}, I: DepartmentLaborRate, O: DepartmentLaborRate },
    { name: "GetCurrentDepartmentRates", options: {}, I: Empty, O: DepartmentLaborRateList },
    { name: "GetProjectLaborRates", options: {}, I: ProjectLaborRateRequest, O: ProjectLaborRateList },
    { name: "CreateProjectLaborRateSnapshot", options: {}, I: ProjectLaborRateRequest, O: ProjectLaborRateList }
]);
